var theme = require('./theme')
var flatten = require('./flatten')

module.exports = theme('nl_NL', flatten(require('./source/nl_NL')))
